/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useCallback,
  useEffect,
  useState,
  useMemo,
  useContext,
  useRef,
} from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Container,
  Collapse,
  Card,
  Modal,
} from "react-bootstrap";

import { NavLink, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus, faThumbsUp } from "@fortawesome/free-solid-svg-icons";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import * as yup from "yup";
import { getCDNImage } from "../globals";
import { currencyFormat, i18nValue, getLocale, parsePreferences } from "../functions";
import { formatDistanceToNow, format, parseISO } from "date-fns";
import { T, TF } from "react-translator-component";
import Screen from "../components/Screen";
import { HotelContext } from "../context/hotel";
import { UserContext } from "../context/user";
import { CheckInContext } from "../context/checkin";
import { serviceTypeIcon } from "../globals";
import { Clock } from "../components/Icons";
import { useItems } from "../hooks/useItems";
import CartButtons from "../components/CartComponents/CartButtons";
import CartSummary from "../components/CartComponents/CartSummary";
import CartItem from "../components/CartComponents/CartItem";
import UpSellingListContainer from "../components/UpSelling/UpSellingListContainer";
import useFoodMenu from "../hooks/useFoodMenu";
import useUpsell from "../hooks/useUpsells";
import useBookable from "../hooks/useBookable";
import { isBelAir, isCostaGalana, isAlvarezArguellez, isRoyal, isDemo, hotelShowsPriceWithoutTaxes } from "../components/CheckIn/hotelConditions";
import { priceWithoutTax } from "../functions";
import processHtml from "../components/processHtml";
import { useHourDisabled } from "../hooks/useHourDisabled";
import { useLanguage } from "../hooks/useLanguage";
import SectionBlocksRenderer from "../components/Sections/SectionBlocksRenderer";


const cartEmpty = {
  qty: 0,
  total: 0,
  desc: "",
  items: [],
};

const normalizeActionMenuButtons = (value) => {
  if (!value) return [];

  const rawItems = Array.isArray(value) ? value : [value];

  return rawItems
    .map((item) => {
      if (!item) return null;

      if (typeof item === "string") {
        try {
          const parsed = JSON.parse(item);
          if (Array.isArray(parsed)) {
            return parsed;
          }
          return parsed;
        } catch (error) {
          return { value: item, customTitle: item };
        }
      }

      return item;
    })
    .flat()
    .filter(Boolean)
    .map((item) => ({
      value: item.value || item.id,
      customTitle: item.customTitle || item.title || item.label || item.value || item.id,
      customTitleI18n: item.customTitleI18n || item.titleI18n || {},
    }))
    .filter((item) => item.value);
};

const _OBSERVATIONS_HEIGHT_MIN = 76;

const Service = (props) => {
  const refObservation = useRef(null);
  const { pathname } = useLocation();

  const location = useLocation();
  const navigate = useNavigate();
  const [type, setType] = useState(null);
  const [typeItems, setTypeItems] = useState(null);

  const {
    theme,
    data: hotel,
    getUrlPath,
    sectionsByCode,
    currency
  } = useContext(HotelContext);
  const {
    activeRequestsQty,
    activeRequests,
    setDoNotDisturb,
    doNotDisturb,
    language,
    requestCreate,
    requestedCart,
    inStay
  } = useContext(UserContext);
  const { data: checkIn } = useContext(CheckInContext)



  let showDateTime = false;
  let dateTitle = "Fecha y Hora";
  let showCombo = false;
  let comboKeys = [];
  let pickerTitle = "Seleccione un servicio";

  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");
  const [extraInfo, setExtraInfo] = useState("");
  const [image, setImage] = useState("");
  const [showSectionImageOrIcon, setShowSectionImageOrIcon] = useState(false);
  const [buttonTitle, setButtonTitle] = useState(T("general.request"));
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [confirmToRequest, setConfirmToRequest] = useState(false);
  const [listItemsArray, setListItemsArray] = useState([]);
  const [optionsArray, setOptionsArray] = useState([]);
  const [summary, setSummary] = useState(false);
  const [cart, setCart] = useState(cartEmpty);
  const [cartItemsCustomizations, setCartItemsCustomizations] = useState(null);
  const [showFloatCart, setShowFloatCart] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const [showSendButton, setShowSendButton] = useState(false);
  const [prevRequests, setPrevRequests] = useState([]);
  const [showPrevRequestsDetail, setShowPrevRequestsDetail] = useState(false);
  const [customMessage, setCustomMessage] = useState(null);
  const [observationScreen, setObservationScreen] = useState(false);
  const [observationPlaceholder, setObservationPlaceholder] = useState(
    "request.generic.observation"
  );
  const [observations, setObservations] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [menuObservation, setMenuObservation] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [menu, setMenu] = useState(null);
  const [showCustomizationMessages, setShowCustomizationMessages] = useState({});
  const { getFoodMenu } = useFoodMenu();
  const { getUpsellingShortToList } = useUpsell();
  const { getItemsByType } = useItems();
  const { getBookableList } = useBookable();

  const [requestId, setRequestId] = useState(null);
  const [loadingDataByParams, setLoadingDataByParams] = useState(false);
  const [searchParams] = useSearchParams();

  const [deliveryPoint, setDeliveryPoint] = useState();
  const { validateHourDisabled } = useHourDisabled(`service_${type}`);
  const currentServiceSection = sectionsByCode["service_" + type];
  const actionMenuButtons = useMemo(() => {
    return normalizeActionMenuButtons(currentServiceSection?.extras?.foodMenuIds);
  }, [currentServiceSection]);
  const [showCoverHourDisabled, setShowCoverHourDisabled] = useState('');

  const containerRef = useRef(null);
  const { defaultLanguage } = useLanguage();
  let hasTaxes = hotelShowsPriceWithoutTaxes(hotel.id);
  const filteredCupsList = useCallback((cupsItems) => {

    if (!cupsItems) return []

    console.log('1901 - cupsItems', cupsItems)

    if (checkIn) {


      const { arrivalMode, rate, RoomCategory, balance } = checkIn;
      let filteredCups = [];

      const reservation_roomcategory = RoomCategory?.id || "";


      cupsItems.map(cup => {

        let showCup = true;

        if (cup.arrivalMode && cup.arrivalMode.length > 0 && arrivalMode) {
          showCup = cup.arrivalMode.includes(arrivalMode);
        }

        if (cup.roomTypes && cup.roomTypes.length > 0) {
          showCup = cup.roomTypes.includes(reservation_roomcategory);
        }

        if (cup.rates && cup.rates.length > 0) {
          const _rates = cup.rates.filter(r => r === rate);
          showCup = _rates.length > 0;
        }

        if (showCup) {
          filteredCups.push(cup);
        }
      })

      return filteredCups;
    } else {
      return cupsItems;
    }
  }, [checkIn]);

  useEffect(() => {
    // PARCHE: si la estadia es != in_stay, entonces redirigir a la pantalla de home
    // TODO::: se debe crear un link con tiempo caducable en base a la estadía del huesped
    if (!isAlvarezArguellez(hotel?.id)) return;
    // Preferir status del check-in (ya disponible tras identify) sobre UserContext.inStay (llega async)
    if (checkIn?.status === "in_stay") return;
    if (!checkIn?.id) return;
    navigate(getUrlPath('/home'), { replace: true })
  }, [hotel?.id, checkIn?.id, checkIn?.status, inStay])

  useEffect(() => {
    setShowCoverHourDisabled(validateHourDisabled);
  }, [validateHourDisabled]);

  useEffect(() => {
    if (containerRef.current) {
      const listServiceSection = containerRef.current.querySelectorAll('.service-section .container');
      console.log('containerRef-listServiceSection', listServiceSection);
      const sectionsArray = Array.from(listServiceSection);
      sectionsArray?.map((el) => {
        const listItems = el.querySelectorAll('.cart-item');
        if (Array.from(listItems).length == 0) {
          const noItems = el.querySelector('.cart-no-items');
          if (noItems) {
            noItems.style.display = 'block';
          }
        }
      })
    }
  }, [containerRef?.current]);

  let validationSchema = yup.object().shape({
    observations: yup.string().nullable().when("type", (type, schema) => {
      if (type === "lost_objects" || type === "breakage_report" || type === "general")
        return schema.required("yup.required");
      return schema;
    }),
  });

  let listTitle = "";
  let periodItems = [];
  let _descDefault = "";
  let _extraInfoDefault = "";

  useEffect(() => {
    let _pathname = location.pathname;
    if (_pathname[_pathname.length - 1] == "/") {
      _pathname = _pathname.slice(0, -1);
    }
    _pathname = _pathname.split("/");
    let _type = _pathname[_pathname.length - 1];
    _type = _type.replace("service_", "");

    setType(_type);

    const searchParams = new URLSearchParams(location.search);
    const _deliveryPoint = searchParams.get("dp")?.trim() || "";
    if (_deliveryPoint) {
      setDeliveryPoint(_deliveryPoint);
    } else {
      if (_type === 'spa') {
        setDeliveryPoint('spa');
      }
      if (_type === 'pool_service') {
        setDeliveryPoint('pool');
      }
    }

    //--- Cargo info del item a editar -->
    if (_type == 'room_service' || _type == 'gift_store' || _type == 'spa') {
      const rId = searchParams.get("request");
      if (rId) {
        // console.log('requestedCart', requestedCart);
        if (requestedCart?.requestId && requestedCart?.requestId == rId) {

          setRequestId(rId);
          cartInitByParams();

        } else {
          alert('No se pudo editar el pedido');
        }
      }
    }
    //<-- Cargo info del item a editar ---



  }, []);

  useEffect(() => {
    if (type == undefined) {
      return;
    }

    let _checkOpenRequests = true;
    let _blockIfHasOpenRequests = false;
    let _showButton = true;
    let _optionsArray = [];
    let _showSectionImageOrIcon = false;
    let _observationScreen = "main";

    switch (type) {
      case "donotdisturb":
        _showSectionImageOrIcon = true;
        _checkOpenRequests = false;
        _observationScreen = false;
        setButtonTitle(
          doNotDisturb
            ? T("services.donotdisturb.button-title-disable")
            : T("services.donotdisturb.button-title-activate")
        );
        _extraInfoDefault = T("services.donotdisturb.extra-info");
        break;
      case "housekeeping":
        _showSectionImageOrIcon = true;
        _blockIfHasOpenRequests = true;
        _descDefault =
          "Servicio de limpieza de habitación y recambio de ropa blanca";
        _extraInfoDefault = T("services.housekeeping.horary");
        if (isCostaGalana(hotel.id)) {
          _extraInfoDefault = T("services.housekeeping.horary-costa-galana");
        }

        if (hotel.id !== "3b70cefa-4202-48c5-aa21-cdbaef82f182") {
          _optionsArray = [
            [
              "do-not-clean-today",
              T("services.housekeeping.do-not-clean-today"),
              0
            ],
            [
              "do-not-change-towels",
              T("services.housekeeping.do-not-change-towels"),
              0,
            ],
          ];
        }
        setButtonTitle(T("services.housekeeping.button-title"));
        setObservationPlaceholder("request." + type + ".observation");
        break;
      case "room_service":
      case "pool_service":
      case "minibar":
      case "gift_store":
      case "spa":
      case "room_supplies":
      case "pressing":
      case "laundry":
      case "services_booking":
      case "upselling":

        // if (type === "room_service") {
        //   console.log('18jul - AAA')
        //   if (isCostaGalana(hotel.id)) {
        //     console.log('18jul - BBB')
        //     _blockIfHasOpenRequests = true;
        //   }
        // }

        setConfirmToRequest(true);
        _observationScreen = "confirm";
        listTitle = "¿Qué querés comer?";
        const _kReq = {
          room_service: "food_menu",
          pool_service: "food_menu",
          minibar: "food_menu",
          room_supplies: "room_supplies",
          pressing: "pressing",
          laundry: "laundry",
          services_booking: "servicesBooking",
          upselling: "upselling",
          gift_store: "food_menu",
          spa: "food_menu"
        };
        setTypeItems(_kReq[type]);
        _showButton = false;
        if (type === "services_booking" || type === "upselling") {
          _observationScreen = false;
        }
        break;
      case "concierge":
        _optionsArray = [
          ["taxi", "Taxi"],
          ["florist", "Florist"],
          ["car-rental", "Car Rental"],
        ];
        break;
      case "car_valet":
        _showSectionImageOrIcon = true;
        showDateTime = true;
        setObservationPlaceholder("request." + type + ".observation");
        break;
      case "porter":
        break;
      case "wakeup_call":
        _optionsArray = [
          ["hour", "Poner input hora"],
          ["5-min", "Cinco Minutos"],
          ["15-min", "Quince Minutos"],
          ["30-min", "Treinta Minutos"],
        ];
        break;
      case "tray_collection":
        _showSectionImageOrIcon = true;
        _blockIfHasOpenRequests = true;
        setObservationPlaceholder("request." + type + ".observation");
        break;
      case "lost_objects":
        _showSectionImageOrIcon = true;
        _observationScreen = "main";
        setButtonTitle(T("general.report"));
        setObservationPlaceholder("request." + type + ".observation");
        break;
      case "breakage_report":
        _showSectionImageOrIcon = true;
        _observationScreen = "main";
        setButtonTitle(T("general.report"));
        setObservationPlaceholder("request." + type + ".observation");
        break;
      case "general":
        setButtonTitle(T("general.send"));
        _showSectionImageOrIcon = true;
        setObservationPlaceholder("request." + type + ".observation");
        break;
      case "feedback":
        setButtonTitle(T("general.send"));
        _showSectionImageOrIcon = true;
        setObservationPlaceholder("request." + type + ".feedback");
        break;
    }



    const _title = sectionsByCode["service_" + type]
      ? i18nValue(sectionsByCode["service_" + type], "title", language)
      : type;
    setTitle(_title);
    const _desc = sectionsByCode["service_" + type]
      ? i18nValue(sectionsByCode["service_" + type], "desc", language)
      : _descDefault;
    setDesc(_desc);
    const _extraInfo =
      sectionsByCode["service_" + type] &&
        sectionsByCode["service_" + type].extra_info
        ? sectionsByCode["service_" + type].extra_info
        : _extraInfoDefault;
    setExtraInfo(_extraInfo);
    const _image =
      sectionsByCode["service_" + type] &&
        sectionsByCode["service_" + type].image
        ? getCDNImage(sectionsByCode["service_" + type].image)
        : "";
    setImage(_image);
    setShowSectionImageOrIcon(_showSectionImageOrIcon);

    if (_checkOpenRequests) {
      if (activeRequestsQty > 0) {
        const pendingsRequests = activeRequests().filter(
          (i) => i.type === type
        );
        if (pendingsRequests.length > 0) {
          setPrevRequests(pendingsRequests);
          if (_blockIfHasOpenRequests) {
            setCustomMessage(T("request.only-one-for-type"));
            _showButton = false;
            _observationScreen = false;
            _optionsArray = [];
            setTypeItems(null);
            setListItemsArray(null);
          }
        }
      }

    }
    setShowSendButton(_showButton);
    setObservationScreen(_observationScreen);
    setOptionsArray(_optionsArray);


  }, [sectionsByCode, type, activeRequestsQty]);

  // 1. Estado para el error de carga de items
  const [loadItemsError, setLoadItemsError] = useState("");

  useEffect(() => {

    if (actionMenuButtons.length > 0) {
      setMenu(null);
      setLoadItemsError("");
      return;
    }

    if ((type === "room_service" || type === "pool_service" || type === "minibar" || type === "gift_store" || type === "spa") && sectionsByCode["service_" + type]?.extras?.foodMenuId) {
      getFoodMenu(undefined, sectionsByCode["service_" + type].extras.foodMenuId)
        .then((r) => {
          console.log('Respuesta cruda de getFoodMenu:', r);
          if (!r || !r.content || !Array.isArray(r.content) || r.content.length === 0 || r.content.every(section => !section.items || section.items.length === 0)) {
            console.log('getFoodMenu Fail!')
            setLoadItemsError(T("menu.items_not_found")); // Mensaje de error más general
            setMenu(null);
          } else {
            console.log('Setting getFoodMenu')
            setMenu(r);
            setLoadItemsError("");
          }
        })
        .catch((response) => {
          console.error('Error on load items:', response);
          setLoadItemsError(T("menu.fail_laod_items")); // Mensaje de error para la captura
        });
    }
  }, [actionMenuButtons, sectionsByCode, type]);



  useEffect(() => {
    let _initialCheckbobSelecteds = [];
    optionsArray.map((val) => {
      if (val[2] === 1) {
        _initialCheckbobSelecteds.push(val[0]);
      }
    });
    setData({
      ...data,
      items: _initialCheckbobSelecteds,
    });

  }, [optionsArray]);


  useEffect(() => {
    if (typeItems === undefined || !typeItems) {
      return;
    }

    if (typeItems === "servicesBooking") {
      getBookableList().then((r) => setListItemsArray(r));
    } else if (typeItems === "food_menu") {
      let _itemsArray = menu?.content.flatMap(i => i.items)
      setListItemsArray(_itemsArray);
    } else if (typeItems === "upselling") {
      setLoading(true);
      getUpsellingShortToList().then(r => {
        const cupsItems = filteredCupsList(r)
        setListItemsArray(cupsItems)
        setLoading(false);
      });
    } else {
      getItemsByType(typeItems).then((r) => {
        setListItemsArray(r);
      });
    }
  }, [typeItems, menu]);

  const showImageInRows = useMemo(() => {
    if (!listItemsArray) return false;
    let hasPhoto = false;
    listItemsArray.map((i) => (hasPhoto = hasPhoto || i.photo !== null));
    return type === "room_service" || type === "pool_service" || type === "minibar" || type === "gift_store" || type === "spa" || type === "room_supplies" && hasPhoto;
  }, [listItemsArray]);

  const cartAvailavility = useMemo(() => {
    let _r = true;
    if (isCostaGalana(hotel.id) || isBelAir(hotel.id) || isRoyal(hotel.id) || isDemo(hotel.id)) {
      if (type === 'pool_service' || type === 'minibar') {
        _r = false;
      }
    }
    return _r;
  }, [hotel, type])

  const hideOnDisabled = useMemo(() => {
    let _r = false;
    if (isCostaGalana(hotel.id)) {
      _r = true;
    }
    return _r;
  }, [hotel])

  let onPressCheckBox = (item, value) => {
    let checkBoxKeys = data["items"] !== undefined ? data["items"] : [];
    if (value && checkBoxKeys.indexOf(item) === -1) {
      checkBoxKeys.push(item);
    }
    if (!value && checkBoxKeys.indexOf(item) !== -1) {
      checkBoxKeys = checkBoxKeys.filter((val, idx) => val !== item);
    }
    setData({
      ...data,
      items: checkBoxKeys,
    });
  };

  let onSelectCombo = (value) => {
    if (value !== "") {
      let array = [];
      array.push(value);
      setData({
        ...data,
        items: array,
      });
    } else {
      delete data["items"];
      setData({
        ...data,
      });
    }
  };

  // TODO_G: Mejorar esta función
  const cartInitByParams = () => {

    setLoadingDataByParams(true);

    let auxItems = {}
    let auxCustoms = {};
    let auxCustomsItems = {};

    requestedCart.items?.map((el) => {
      if (el.customizations?.length > 0) {
        auxCustoms[el.item.id] = true;

        el.customizations.map((item, index) => {
          Object.keys(item).map((key, idx) => {

            auxCustomsItems = {
              ...auxCustomsItems,
              [el.itemId]: {
                ...(auxCustomsItems[el.itemId] || {}),
                [index]: {
                  ...(auxCustomsItems[el.itemId]?.[index] || {}),
                  [key]: item[key],
                },
              },
            };

          });
        });
      }
      auxItems = { ...auxItems, [el.item.id]: el.qty }
    });

    setTimeout(() => {
      if (auxItems) {
        setData({ items: auxItems });
      }

      if (auxCustoms) {
        setShowCustomizationMessages(auxCustoms);
      }
      if (auxCustomsItems) {
        setCartItemsCustomizations(auxCustomsItems);
      }
      if (requestedCart.observations) {
        setObservations(requestedCart.observations);
      }

      setLoadingDataByParams(false);

    }, [500]);

  }

  const onSave = useCallback(() => {
    setSending(true);
    let _pathname = location.pathname;
    if (_pathname[_pathname.length - 1] === "/") {
      _pathname = _pathname.slice(0, -1);
    }
    _pathname = _pathname.split("/");

    if (type === "donotdisturb") {
      setDoNotDisturb(!doNotDisturb, (r) => {
        navigate(getUrlPath("/services"));
      });
      return;
    }

    const _data = { ...data }
    let _cart = {}

    let auxType = '';

    validationSchema
      .validate(
        {
          type: type,
          date: _data.date,
          items: _data.items,
          observations: observations
        },
        { abortEarly: false }
      )
      .then(function () {

        setTimeout(() => {
          setSending(false);
          setSent(true);
        }, 1000);

        if (
          type === "room_service" ||
          type === "pool_service" ||
          type === "minibar_service" ||
          type === "room_supplies" ||
          type === "pressing" ||
          type === "laundry" ||
          type === "gift_store" ||
          type === "spa"
        ) {
          _cart = { ...cart }
          delete (_cart.desc)
          _cart.items = _cart.items.map(item => {
            delete (item.name)
            delete (item.preferences)
            delete (item.desc)
            item.customizations = item.customizations
            return item;
          })

        }

        if (type == 'spa' || type == 'pool_service') {
          auxType = 'items_sales';
        }

        const payload = {
          // hotelId: hotel.id,
          // roomOccupationId: RoomOccupation.id,
          type: auxType || type,
          data: JSON.stringify(_data),
          cart: JSON.stringify(_cart),
          deliveryPoint: deliveryPoint,
          observations
        };
        if (requestId) {
          payload.id = requestId;
        }

        requestCreate(payload)
          .then((response) => {
            setShowFloatCart(false);
          })
          .catch((response) => {
            console.log("error", response);
          });
      })
      .catch(function (err) {
        const validationErrors = {};
        err.inner?.forEach((error) => {
          if (error.path) {
            validationErrors[error.path.replace(".", "_")] = error.message;
          }
        });
        setErrors(validationErrors);
        setSending(false);
      });
  }, [type, data, cart, observations]);
  const handleDeleteItem = (itemId) => {
    const updatedItems = cart.items.filter(item => item.itemId !== itemId);
    const removedItem = cart.items.find(item => item.itemId === itemId);
    let updatedDesc = cart.desc;
    if (removedItem) {
      updatedDesc = updatedDesc.replace(`${removedItem.qty}x${removedItem.name}`, '').trim();
      if (updatedItems.length === 0) {
        updatedDesc = '';
      }
    }

    const updatedCart = {
      ...cart,
      items: updatedItems,
      desc: updatedDesc,
      qty: cart.qty - 1,
      total: cart.total - (removedItem ? removedItem.price : 0)
    };

    setCart(updatedCart);

    const updatedDataItems = { ...data.items };
    updatedDataItems[itemId] = (updatedDataItems[itemId] ?? 0) - 1;
    updatedDataItems[itemId] = updatedDataItems[itemId] >= 0 ? updatedDataItems[itemId] : 0;

    setData({
      ...data,
      items: updatedDataItems
    });

    // Manejo de mostrar/ocultar mensajes de personalización
    if (updatedDataItems[itemId] > 0) {
      setShowCustomizationMessages(prevState => ({
        ...prevState,
        [itemId]: true
      }));
    } else {
      setShowCustomizationMessages(prevState => ({
        ...prevState,
        [itemId]: false
      }));
    }
    if (updatedCart.qty === 0) {
      setSummary(false);
    }
  };



  const handleAddButtonClick = (itemId) => {
    setShowCustomizationMessages(prevState => ({
      ...prevState,
      [itemId]: true
    }));
  };



  const HandleConfirmOnSave = () => {
    return (
      <Modal show={openModal} centered backdrop="static" onHide={() => setOpenModal(false)}>
        <Modal.Header style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}>
          <Modal.Title className="ms-auto">
            <span className="font-size-md text-center">
              {T("services.confirm-request")}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Footer style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",

        }}>
          <div>
            <small onClick={() => setOpenModal(false)}>
              {T("general.back")}
            </small>
          </div>
          <Button variant="success" onClick={onSave}>
            {T("general.confirm")}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  useEffect(() => {
    if (loadingDataByParams) return;

    if (data && data.items) {

      // TODO:: mejorar mucho esto
      const _cart = { ...cartEmpty };
      _cart.items = []; // TODO:::parche porque acumulaba los anteriores
      const _desc = [];
      if (listItemsArray) {

        console.log('2222 - listItemsArray', listItemsArray);
        console.log('2222 - data.items', data.items);

        Object.keys(data.items).map((i) => {

          const p = listItemsArray.filter((itprod) => itprod.id === i);
          if (p[0] && data.items[i] > 0) {


            console.log('cartItemsCustomizations', cartItemsCustomizations);

            const _name = i18nValue(p[0], "name", language) || p[0].name;
            const _description = i18nValue(p[0], "description", language) || p[0].description;

            _cart.items.push({
              itemId: p[0].id,
              name: _name,
              type: p[0].type,
              desc: _description,
              price: p[0].price,
              vat: p[0].vat,
              account: p[0].account,
              preferences: parsePreferences(p[0].preferences),
              customizations: cartItemsCustomizations && cartItemsCustomizations[p[0].id] ? Object.values(cartItemsCustomizations[p[0].id]) || [] : [],
              subAccount: p[0].subAccount,
              qty: data.items[i],
              total: parseFloat((p[0].price * data.items[i]).toFixed(2)),
            });
            _desc.push(data.items[i] + "x" + _name);
            _cart.qty += data.items[i];
            _cart.total += parseFloat((p[0].price * data.items[i]).toFixed(2));
          }
        });
      }
      _cart.desc = _desc.join(", ");

      setCart(_cart);
      setShowFloatCart(_cart.items.length > 0);
    }

  }, [data, language, cartItemsCustomizations, listItemsArray, loadingDataByParams]);

  const cartReset = useCallback(() => {
    if (requestId) {
      navigate(`/${hotel.code}/requests/${requestId}`);
    } else {
      setShowCustomizationMessages({});
      setData({
        ...data,
        items: [],
      });
    }
  }, [data]);

  const handleObservationChange = useCallback((e) => {
    refObservation.current.style.height = "1px";
    let scrollHeight = refObservation.current.scrollHeight;
    if (scrollHeight < _OBSERVATIONS_HEIGHT_MIN) {
      scrollHeight = _OBSERVATIONS_HEIGHT_MIN;
    }
    refObservation.current.style.height = scrollHeight + "px";
    setObservations(e.target.value);
  }, []);

  // TODO_G: REPLANTEAR FUNCIONES (las dejé como estaban en código)
  const handleCartAddButtonClick = (id) => {
    handleAddButtonClick(id);
    const _items = { ...data.items };
    _items[id] = (_items[id] ?? 0) + 1;
    setData({
      ...data,
      items: _items,
    });
  }
  const handleCartDeleteButtonClick = (id) => {
    handleDeleteItem(id);
    const _items = { ...data.items };
    _items[id] = (_items[id] ?? 0) - 1;
    _items[id] = _items[id] >= 0 ? _items[id] : 0;
    setData({
      ...data,
      items: _items,
    });
  }

  // 1. Agrego nuevos estados para el buscador y la categoría activa
  const [searchTerm, setSearchTerm] = useState("");
  // Cambiar el estado inicial del tab activo a 0 (Todos)
  const [activeCategoryIndex, setActiveCategoryIndex] = useState(0);

  // 2. Función para filtrar items por búsqueda
  const filterItems = (items) => {
    if (!searchTerm) return items;
    return items.filter(item => {
      const name = i18nValue(item, "name", language) || item.name || "";
      const desc = i18nValue(item, "description", language) || item.description || "";
      return (
        name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        desc.toLowerCase().includes(searchTerm.toLowerCase())
      );
    });
  };

  // TODO::: parche
  if (type === "room_service" && (!menu || listItemsArray?.length === 0 || loadingDataByParams)) {
    // Si hay un error de carga, lo mostramos en lugar del spinner.
    if (loadItemsError) {
      return (
        <Screen
          section="service"
          title={title}
          description={!sent ? desc : ""}
          backUrl={!summary ? (requestId ? `./requests/${requestId}` : `./services`) : null}
        >
          <div className="alert alert-danger text-center mt-5" role="alert">
            {loadItemsError}
          </div>
        </Screen>
      );
    }
    // Si no hay error pero sigue cargando o no hay menú/items, mostramos el spinner.
    return <div className="loading text-center mt-5">
      <div className="spinner-border" role="status"></div>
    </div>
  }
  // TODO::: parche



  // console.log('1901 - {!summary ? (requestId ? `./requests/${requestId}` : `./services`) : null}', summary, requestId, !summary ? (requestId ? `./requests/${requestId}` : `./checkin/status`) : null )

  const isMenuWithTabs = menu && (type === "room_service" || type === "restaurants" || type === "gift_store" || type === "spa") && typeItems === "food_menu";

  return (
    <Screen
      section="service"
      title={title}
      description={!sent ? desc : ""}

      backUrl={!summary ? (requestId ? `./requests/${requestId}` : `./services`) : null}
      // backUrl={!summary ? (requestId ? `./requests/${requestId}` : `./checkin/status`) : null}
      onBackClick={() => {
        if (summary) {
          setSummary(false);
          return true;
        }
      }}
    >
      {loading && <div
        className="loading d-flex justify-content-center align-items-center"
        style={{ height: "100vh", width: "100vw", position: "fixed", top: 0, left: 0 }}
      >
        <div className="spinner-border"></div>
      </div>}

      {/* Mostrar el mensaje de error si loadItemsError no está vacío */}
      {loadItemsError && (
        <div className="alert alert-danger text-center mt-3" role="alert">
          {loadItemsError}
        </div>
      )}

      {
        showCoverHourDisabled
          ?
          <div className="cover-hour-disabled">
            <p>{T(showCoverHourDisabled)}</p>
          </div>
          :
          <>

            {/* {prevRequests.length > 0 && (
          <>
            <Button
              size={"lg"}
              variant={"link"}
              type={"button"}
              style={{
                border: "none",
                color: "#333",
                fontWeight: 200,
                textDecoration: "none",
                fontSize: 16,
                marginBottom: 10,
              }}
              block={true}
              onClick={() =>
                setShowPrevRequestsDetail(!showPrevRequestsDetail)
              }
            >
              <FontAwesomeIcon
                size="sm"
                icon={!showPrevRequestsDetail ? faChevronDown : faChevronUp}
                color="#999"
                className="mr-2"
              />
              {prevRequests.length === 1
                ? TF("services.active-request", prevRequests.length)
                : TF("services.active-requests", prevRequests.length)}
            </Button>
            <Collapse
              in={showPrevRequestsDetail}
              className={"open-requests"}
            >
              <Card border="default" bg="light" className="mb-4">
                <Card.Body>
                  {prevRequests.map((r) => {

                    return (
                      <NavLink
                        key={`req-${r.id}`}
                        style={{ color: "black" }}
                        className={"open-request-item"}
                        to={{ pathname: `../requests/${r.id}${r.type === "general" ? "/messages" : ""}` }}
                        state={{ from: pathname }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <span style={{ width: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", marginLeft: "5px" }}>
                            {r?.observations}
                          </span>
                        </div>
                        <span style={{ lineHeight: 2 }}>{format(parseISO(r.createdAt), "dd MMM", { locale: getLocale(language) })}</span>
                        <span className={`label label-sm label-light-${r.status} label-inline text-uppercase d-flex align-items-center`}>
                          {T(`services.status.${r.status}`)}
                        </span>
                      </NavLink>
                    );
                  })}
                </Card.Body>
              </Card>
            </Collapse>
          </>
        )}
        */}
            {theme === 1 && (
              <>
                <div
                  style={{
                    height: "280px",
                    backgroundColor: "#DDD",
                    backgroundImage: "url(" + image + ")",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    borderEndStartRadius: 15,
                    borderEndEndRadius: 15,
                  }}
                ></div>
                <div
                  style={{
                    marginTop: "-50px",
                    backgroundColor: "#FFF",
                    marginLeft: 20,
                    marginRight: 20,
                    borderRadius: 15,
                    padding: 15,
                    boxShadow: "rgb(0 0 0 / 10%) 0px 0px 10px 3px",
                  }}
                >
                  <h5
                    style={{
                      fontSize: 20,
                      color: "#c77f47",
                      fontWeight: "600",
                      textTransform: "uppercase",
                      textAlign: "center",
                      marginBottom: 15,
                    }}
                  >
                    {title}
                  </h5>
                  <p
                    className="general-text mb-0"
                    style={{ textAlign: "center", whiteSpace: "pre-wrap" }}
                  >
                    {desc}
                  </p>
                </div>
              </>
            )}
            {theme === 2 && (
              <>
                <div
                  style={{
                    height: "300px",
                    backgroundColor: "#999",
                    backgroundImage: "url(" + image + ")",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                  }}
                ></div>
                <div style={{ margin: 20 }}>
                  <h5
                    style={{
                      color: "#c77f47",
                      fontWeight: "900",
                      textTransform: "uppercase",
                      marginBottom: 15,
                    }}
                  >
                    {title}
                  </h5>
                  <p className="general-text" style={{ whiteSpace: "pre-wrap" }}>
                    {desc}
                  </p>
                </div>
              </>
            )}

            {theme === 3 && showSectionImageOrIcon && !sent && (
              <>
                {false && image && (
                  <div
                    style={{
                      borderRadius: 10,
                      height: "25vh",
                      backgroundColor: "#999",
                      backgroundImage: "url(" + image + ")",
                      backgroundPosition: "center",
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                    }}
                  ></div>
                )}
                {(true || !image) && (
                  <div className="section-image text-center">
                    <div
                      className="service-icon"
                      style={{
                        borderRadius: "50%",
                        background: "#FFF",
                        marginTop: 20,
                        display: "inline-block",
                        padding: 40,
                        boxShadow: "0 10px 20px #CCC",
                        marginBottom: 15,
                      }}
                    >
                      {serviceTypeIcon(type.replace("service_", ""), 100)}
                    </div>
                  </div>
                )}
              </>
            )}

            {!sending && (
              <SectionBlocksRenderer
                section={currentServiceSection}
                language={language}
                sectionsByCode={sectionsByCode}
                getUrlPath={getUrlPath}
              />
            )}

            {sending && (
              <div className="loading text-center mt-5">
                <div className="spinner-border" role="status"></div>
              </div>
            )}



            {!sending && sent && (
              <Container>
                <Row>
                  <Col className="service-sent text-center mt-5">
                    <div
                      className="text-center mt-5"
                      style={{
                        background: "white",
                        border: "1px solid #EEE",
                        borderRadius: 10,
                        padding: "10px 20px",
                      }}
                    >
                      <span className="font-size-sm d-block mb-3">
                        <FontAwesomeIcon
                          icon={faThumbsUp}
                          style={{ fontSize: 80, color: "#3699ff", marginTop: -20 }}
                          className="mb-1"
                        />
                      </span>
                      <p style={{ fontSize: "0.9rem" }} className="mb-4">
                        {T("services.sent-text")}
                      </p>
                      <div className="mb-2">
                        <NavLink
                          className="btn btn-primary m-1 text-white"
                          style={{ color: "black" }}
                          to={{ pathname: "/" + hotel.code + "/checkin/status" }}
                          state={{ from: pathname }}
                          replace
                        >
                          {T("services.go-to-requests")}
                        </NavLink>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            )}
            {!sending && !sent && (
              <Form>
                <Form.Group>
                  {extraInfo && (
                    <p
                      className="service-extra-info general-text-sm mb-0 mt-4"
                      style={{
                        background: "white",
                        border: "1px solid #EEE",
                        borderRadius: 10,
                        padding: "10px 20px",
                      }}
                    >
                      {extraInfo}
                    </p>
                  )}

                  {deliveryPoint && <div style={{ background: "#fff0a8", borderRadius: 8, textAlign: "center", padding: "5px 15px", border: "1px solid #e8d36c" }}>
                    <small>{T('request.delivery-point')}</small>
                    <h5>{String(deliveryPoint).toUpperCase()}</h5>
                  </div>}

                  {actionMenuButtons.length > 0 && (
                    <div style={{ margin: "20px 0 30px 0" }}>
                      <h5 className="general-title">Menus disponibles</h5>
                      {actionMenuButtons.map((buttonMenu, index) => (
                        <div className="mb-3" key={`service-menu-button-${buttonMenu.value}-${index}`}>
                          <NavLink
                            to={{ pathname: `../menu/${buttonMenu.value}`, id: buttonMenu.value }}
                            state={{ from: pathname }}
                            className="mb-2 d-block w-100 text-center"
                            style={{
                              color: "#555",
                              border: "1px solid #CCC",
                              textTransform: "uppercase",
                              minHeight: 50,
                              backgroundColor: "#EEE",
                              lineHeight: "50px",
                              fontWeight: "bold",
                              borderRadius: 8,
                              padding: "0 12px",
                            }}
                          >
                            {i18nValue(buttonMenu, "customTitle", language)}
                          </NavLink>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Datepicker */}
                  {showDateTime ? (
                    <div style={{ marginBottom: "30px" }}>
                      <h5 className="general-title">{dateTitle}</h5>
                      <Form.Control
                        type={"datetime-local"}
                        value={data.date}
                        min={new Date()}
                        onChange={(event) =>
                          setData({ ...data, date: event.target.value })
                        }
                      />
                    </div>
                  ) : null}



                  {customMessage && <p className="custom-message">{customMessage}</p>}

                  {optionsArray && optionsArray.length > 0 && (
                    <div style={{ margin: "20px 10px 30px 10px" }}>
                      {/* <h5 className="general-title">{checkBoxTitle}</h5> */}
                      {optionsArray.map((val, idx) => {
                        return (
                          <Form.Check
                            key={`chk-${idx}`}
                            name={"option"}
                            label={val[1]}
                            type={"checkbox"}
                            value={val[0]}
                            onChange={(e) => {
                              onPressCheckBox(val[0], e.target.checked);
                            }}
                            className={"services-check general-text"}
                            defaultChecked={val[2] === 1}
                          />
                        );
                      })}
                    </div>
                  )}

                  {isMenuWithTabs && (
                    <div className="mt-3" style={{ paddingBottom: 10, marginBottom: 20, borderBottom: "1px solid #ddd" }}>
                      <input
                        type="text"
                        className="form-control mb-3 text-center pt-3 pb-3 input-menu-search"
                        placeholder={type === "restaurants" ? T("menu.search") : T("menu.search_room_service")}
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                      />
                      <div className="mb-3 d-flex flex-wrap" style={{ gap: 8, justifyContent: "center" }}>
                        <button
                          key={-1}
                          type="button" // Se agrega type="button"
                          className={`btn btn-sm pt-2 pb-2  ${activeCategoryIndex === 0 ? 'btn-secondary' : 'btn-outline-secondary'}`}
                          style={{ minWidth: 100, borderColor: activeCategoryIndex === 0 ? "#697279" : "#ccc" }}
                          onClick={() => setActiveCategoryIndex(0)}
                        >
                          {T("menu.all")}
                        </button>
                        {menu.content.map((section, idx) => (
                          <button
                            key={idx + 1}
                            type="button" // Se agrega type="button"
                            className={`btn btn-sm pt-2 pb-2 ${activeCategoryIndex === idx + 1 ? 'btn-secondary' : 'btn-outline-secondary'}`}
                            style={{ minWidth: 100, borderColor: activeCategoryIndex === idx + 1 ? "#697279" : "#ccc" }}
                            onClick={() => setActiveCategoryIndex(idx + 1)}
                          >
                            {i18nValue(section, "title", language, null, null, defaultLanguage()) || TF("menu.category", [idx + 1])}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}

                  {isMenuWithTabs ? (
                    activeCategoryIndex === 0 ? (
                      <div className="section-card" key={-1}>
                        {menu.content.map((section, idx) => (
                          <div key={idx}>
                            <h6 className="section-title">{i18nValue(section, "title", language)}</h6>
                            <p className="section-description">{i18nValue(section, "description", language)}</p>
                            {section.items && filterItems(section.items).map((item, itemIndex) => (
                              item && (
                                <CartItem
                                  key={`section-item-${item.id}`}
                                  item={item}
                                  value={data["items"] !== undefined ? data["items"][item.id] ?? 0 : 0}
                                  language={language}
                                  currency={currency}
                                  showImages={showImageInRows}
                                  showCustomizationMessages={showCustomizationMessages}
                                  handleAddButtonClick={handleCartAddButtonClick}
                                  handleDeleteItem={handleCartDeleteButtonClick}
                                  cartAvailavility={cartAvailavility}
                                  hideOnDisabled={hideOnDisabled}
                                />
                              )
                            ))}
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div ref={containerRef} style={{ paddingBottom: `${showFloatCart && '100px'}` }}>
                        {listTitle && (
                          <h4 className="service-items-header-title">{listTitle}</h4>
                        )}
                        {menu.content && menu.content.length > 0 && (
                          <>
                            <div key={activeCategoryIndex} className="service-section mt-2 mb-4" style={{
                              padding: "5px",
                              boxShadow: '0 .5rem 1rem rgba(0, 0, 0, .15)',
                              marginBottom: "5px",
                              borderRadius: "5px"
                            }}>
                              <h5 className="section-title text-uppercase pt-2" style={{
                                color: "#a80c00",
                                fontWeight: "bold",
                                padding: "4px",
                                textAlign: "center",
                              }}>{i18nValue(menu.content[activeCategoryIndex - 1], "title", language)}</h5>
                              <p className="section-description text-muted" style={{
                                textAlign: "justify",
                                fontSize: "0.8rem",
                                marginLeft: "5px"
                              }}>{i18nValue(menu.content[activeCategoryIndex - 1], "description", language)}
                              </p>
                              <hr style={{ border: "1px solid #ccc", marginTop: "5px", marginBottom: "5px" }} />
                              <Container>
                                {hideOnDisabled && menu.content[activeCategoryIndex - 1].items && (
                                  <div className="cart-no-items text-center py-3">
                                    <span className="general-text-sm">
                                      {T("request.products_not_available")}
                                    </span>
                                  </div>
                                )}
                                {menu.content[activeCategoryIndex - 1].items && filterItems(menu.content[activeCategoryIndex - 1].items).map((item, itemIndex) => (
                                  item && (
                                    <CartItem
                                      key={`section-item-${item.id}`}
                                      item={item}
                                      value={data["items"] !== undefined ? data["items"][item.id] ?? 0 : 0}
                                      language={language}
                                      currency={currency}
                                      showImages={showImageInRows}
                                      showCustomizationMessages={showCustomizationMessages}
                                      handleAddButtonClick={handleCartAddButtonClick}
                                      handleDeleteItem={handleCartDeleteButtonClick}
                                      cartAvailavility={cartAvailavility}
                                      hideOnDisabled={hideOnDisabled}
                                    />
                                  )
                                ))}
                              </Container>
                            </div>
                          </>
                        )}
                      </div>
                    )
                  ) : null}


                  {listItemsArray &&
                    listItemsArray.length > 0 &&
                    typeItems !== "servicesBooking" &&
                    (typeItems !== "food_menu" || type === 'minibar') && typeItems !== "upselling" ? (
                    <Col className={`service-items mt-3`} xs="12">
                      {listTitle && (
                        <h4 className="service-items-header-title">{listTitle}</h4>
                      )}
                      {listItemsArray.map((val) => {
                        if (
                          val.type === "room_supplies" ||
                          val.type === "laundry" ||
                          val.type === "pressing"
                        ) {
                          return (
                            <>
                              <Row className="service-simple-item-row" key={val.id}>
                                <Col>
                                  {showImageInRows /*val.type == 'roomService'*/ && (
                                    <>
                                      {val.photo && (
                                        <img
                                          src={getCDNImage(val.photo)}
                                          className="service-full-item-photo"
                                          alt={val.name}
                                        />
                                      )}
                                      {!val.photo && (
                                        <img
                                          src={"/logo_57.png"}
                                          className="service-full-item-photo no-photo"
                                          alt={val.name}
                                        />
                                      )}
                                      <h6 className="service-full-item-name">
                                        {i18nValue(val, "name", language)}
                                      </h6>
                                      <p className="service-full-item-description mb-0">
                                        {processHtml(i18nValue(val, "description", language))}
                                      </p>
                                      {val.price > 0 && (
                                        <span className="general-text">
                                          <b>{currencyFormat(val.price, currency)}</b>
                                        </span>
                                      )}
                                      {!val.price && (
                                        <span className="general-text text-success">
                                          <b> {T("general.no-charge")}</b>
                                        </span>
                                      )}
                                    </>
                                  )}
                                  {!showImageInRows /*val.type != 'roomService'*/ && (
                                    <div className="d-flex flex-column align-items-start">
                                      <span className="service-simple-item-name mb-0">
                                        {i18nValue(val, "name", language)}

                                      </span>
                                      <span>
                                        {val.price
                                          ? currencyFormat(val.price, currency) + ".-"
                                          : "Sin cargo"}
                                      </span>
                                    </div>
                                  )}
                                  <div
                                    className="service-simple-item-qty"
                                    style={{ float: "right" }}
                                  >
                                    <Button
                                      value={val.id}
                                      onClick={(item) => {
                                        const _items = { ...data.items };
                                        _items[val.id] = (_items[val.id] ?? 0) - 1;
                                        _items[val.id] =
                                          _items[val.id] >= 0 ? _items[val.id] : 0;
                                        setData({
                                          ...data,
                                          items: _items,
                                        });
                                      }}
                                      className={"nud-left"}
                                    >
                                      <FontAwesomeIcon
                                        className="nud-icon"
                                        icon={faMinus}
                                      />
                                    </Button>
                                    <input
                                      id={val.id}
                                      className="nud-number"
                                      min={0}
                                      type={"text"}
                                      readOnly={true}
                                      value={
                                        data["items"] !== undefined &&
                                          data["items"][val.id]
                                          ? data["items"][val.id]
                                          : 0
                                      }
                                    ></input>
                                    <Button
                                      value={val.code}
                                      onClick={(item) => {
                                        const _items = { ...data.items };
                                        _items[val.id] = (_items[val.id] ?? 0) + 1;
                                        setData({
                                          ...data,
                                          items: _items,
                                        });
                                      }}
                                      className={"nud-right"}
                                    >
                                      <FontAwesomeIcon
                                        className="nud-icon"
                                        icon={faPlus}
                                      />
                                    </Button>
                                  </div>
                                  {hasTaxes && val?.price > 0 && (
                                    <span className="font-size-sm d-flex flex-wrap" style={{ fontSize: "0.68rem", fontStyle: "italic", color: "#5a5a5a" }}> {T("menu.price_without_taxes")}: {currencyFormat(priceWithoutTax(val.price), currency)}</span>
                                  )}
                                </Col>
                              </Row>

                            </>
                          );
                        } else if (type === "minibar") {
                          return (
                            <Row className="service-simple-item-row" key={val.id}>
                              <Col>
                                {showImageInRows /*val.type == 'roomService'*/ && (
                                  <>
                                    {val.photo && (
                                      <img
                                        src={getCDNImage(val.photo)}
                                        className="service-full-item-photo"
                                        alt={val.name}
                                      />
                                    )}
                                    {!val.photo && (
                                      <img
                                        src={"/logo_57.png"}
                                        className="service-full-item-photo no-photo"
                                        alt={val.name}
                                      />
                                    )}
                                    <h6 className="service-full-item-name">
                                      {i18nValue(val, "name", language)}
                                    </h6>
                                    <p className="service-full-item-description mb-0">
                                      {processHtml(i18nValue(val, "description", language))}
                                    </p>
                                    {val.price > 0 && (
                                      <div className="d-flex justify-content-between flex-column">
                                        <span className="general-text">
                                          <b>{currencyFormat(val.price, currency)}</b>
                                        </span>
                                        {hasTaxes && (
                                          <span className="general-text font-size-sm" style={{ fontSize: "0.68rem", fontStyle: "italic", color: "#5a5a5a" }}> {T("menu.price_without_taxes")}: {currencyFormat(priceWithoutTax(val.price), currency)}</span>
                                        )}
                                      </div>
                                    )}
                                    {!val.price && (
                                      <span className="general-text text-success">
                                        <b> {T("general.no-charge")}</b>
                                      </span>
                                    )}
                                  </>
                                )}
                                {!showImageInRows /*val.type != 'roomService'*/ && (
                                  <>
                                    {/* <span className="service-simple-item-name mb-0">
                                      {i18nValue(val, "name", language)}
                                    </span>
                                    <span className="service-simple-item-price font-sm">
                                      {val.price
                                        ? currencyFormat(val.price, currency) + ".-"
                                        : "Sin cargo"}
                                    </span> */}
                                    <h6 className="service-full-item-name">
                                      {i18nValue(val, "name", language)}
                                    </h6>
                                    <p className="service-full-item-description mb-0">
                                      {processHtml(i18nValue(val, "description", language))}
                                    </p>
                                    {val.price > 0 && (
                                      <span className="general-text">
                                        <b>{currencyFormat(val.price, currency)}</b>
                                      </span>
                                    )}
                                    {!val.price && (
                                      <span className="general-text text-success">
                                        <b> {T("general.no-charge")}</b>
                                      </span>
                                    )}
                                  </>
                                )}
                              </Col>
                            </Row>
                          );
                        } else return false;
                      })}
                    </Col>
                  ) : null}



                  {listItemsArray &&
                    listItemsArray.length > 0 &&
                    typeItems === "servicesBooking" && (
                      <Container className="mt-3">

                        {listItemsArray.map((val) => {
                          if (!val.visible && !val.active) return false;

                          let _url = false
                          if (typeItems === "servicesBooking") {
                            _url = `/${hotel.code}/service_booking/${val.id}`;
                          }


                          return (
                            <NavLink
                              className="mb-2 d-block"
                              to={{
                                pathname: _url,
                              }}
                              state={{ from: pathname }}
                              key={val.id}
                            >
                              <Row className="service-booking-item-row">
                                <Col>
                                  {val.photo && (
                                    <img
                                      src={getCDNImage(val.photo)}
                                      className="service-full-item-photo photo-size-lg"
                                      alt={val.name}
                                    />
                                  )}
                                  {!val.photo && (
                                    <img
                                      src={"/logo_57.png"}
                                      className="service-full-item-photo photo-size-lg no-photo"
                                      alt={val.name}
                                    />
                                  )}
                                  <h6 className="service-full-item-name">
                                    {i18nValue(val, "name", language)}
                                  </h6>
                                  <p className="service-full-item-description">
                                    {processHtml(i18nValue(val, "description", language))}
                                  </p>
                                  <div
                                    className="general-text-sm mt-2 pt-2"
                                    style={{ borderTop: "1px solid #EFEFEF" }}
                                  >
                                    <Row>
                                      <Col className="p-0" style={{ marginTop: 3 }}>
                                        {val.duration && (
                                          <span>
                                            <Clock
                                              className="d-inline-block mr-1 align-bottom"
                                              width={20}
                                              height={20}
                                              color="#999"
                                            />
                                            {val.durationToShow} minutes
                                          </span>
                                        )}
                                      </Col>
                                      <Col className="p-0 text-right">
                                        {val.price > 0 && (
                                          <span className="general-text">
                                            <b>{currencyFormat(val.price, currency)}</b>
                                          </span>
                                        )}
                                        {false && !val.price && (
                                          <span className="general-text text-success">
                                            <b> {T("general.no-charge")}</b>
                                          </span>
                                        )}
                                      </Col>
                                    </Row>
                                  </div>
                                </Col>
                              </Row>
                            </NavLink>
                          );
                        })}
                      </Container>
                    )}

                  {listItemsArray &&
                    listItemsArray.length > 0 && typeItems === "upselling" && (
                      <UpSellingListContainer cupsList={listItemsArray} lang={language} currency={currency} path={pathname} />
                    )}

                  {showCombo ? (
                    <div style={{ marginBottom: "40px" }}>
                      <h5
                        style={{
                          color: "#c77f47",
                          fontWeight: "600",
                          textTransform: "uppercase",
                        }}
                      >
                        {pickerTitle}
                      </h5>
                      <Form.Control
                        onChange={(event) => onSelectCombo(event.target.value)}
                        rows={3}
                        as={"select"}
                        placeholder={"Notes"}
                      >
                        <option value={""}>Select a option</option>
                        {comboKeys.map((k, v) => {
                          return <option value={k}>{k}</option>;
                        })}
                        ;
                      </Form.Control>
                    </div>
                  ) : null}

                  {observationScreen && observationScreen === "main" && (
                    <>
                      <Form.Control
                        className="services-textarea"
                        type={"textarea"}
                        value={undefined}
                        placeholder={`${T(observationPlaceholder)}...`}
                        ref={refObservation}
                        maxLength={type !== "feedback" ? 200 : null}
                        onChange={(e) => handleObservationChange(e)}
                        as="textarea"
                        isInvalid={errors.observations}
                        style={{
                          fontSize: "0.75rem",
                          resize: "none",
                          boxShadow: '0px 10px 20px rgba(204, 204, 204, 0.7)',
                          minHeight: _OBSERVATIONS_HEIGHT_MIN,
                        }}
                      />
                      {errors.observations && (
                        <Form.Control.Feedback type="invalid">
                          {T(errors.observations)}
                        </Form.Control.Feedback>
                      )}
                    </>
                  )}
                </Form.Group>
              </Form>
            )
            }
            {
              !sent && !sending && (
                <div className="footer-container">
                  {showSendButton && (
                    <div>
                      <Button
                        size={"lg"}
                        variant={"primary"}
                        type={"button"}
                        block={true}
                        disabled={sending}
                        onClick={() => {
                          if (confirmToRequest) {
                            setOpenModal(true)
                          } else {
                            onSave()
                          }
                        }}
                      >
                        {buttonTitle}
                      </Button>
                    </div>
                  )}

                  {summary && cart.items.length > 0 && (
                    <CartSummary
                      cart={cart}
                      summary={summary}
                      setSummary={setSummary}
                      setMenuObservation={setMenuObservation}
                      selectedOptions={selectedOptions}
                      setSelectedOptions={setSelectedOptions}
                      setCartItemsCustomizations={setCartItemsCustomizations}
                      setConfirmToRequest={setConfirmToRequest}
                      setOpenModal={setOpenModal}
                      observations={observations}
                      setObservations={setObservations}
                      language={language}
                      handleDeleteItem={handleDeleteItem}
                      isEdit={requestId}
                    />
                  )}

                  {showFloatCart &&
                    <div className="cart-container">
                      <Row>
                        <Col xs={8}>
                          <div className="mt-1 py-2">
                            <span className="cart-title">{T("request.your-request")}</span>
                            <small clasName="text-muted">{` (${cart.qty} ${cart.qty > 1 ? T("request.products") : T("request.product")})`}</small>
                          </div>
                          {/* <div className="cart-title">{`${cart.qty} ${cart.qty > 1 ? T("request.products") : T("request.product")}`}</div> */}
                          <span className="cart-description" style={{ textTransform: "uppercase" }}>{cart.desc}</span>
                        </Col>
                        <Col xs={4} className="cart-price pt-2" style={{ lineHeight: 1.25 }}>
                          <div>{currencyFormat(cart.total, currency)}</div>
                        </Col>
                      </Row>
                      <CartButtons
                        setSummary={setSummary}
                        onSave={onSave}
                        confirmToRequest={confirmToRequest}
                        cartReset={cartReset}
                        cart={cart}
                      />
                    </div>}
                  <HandleConfirmOnSave />
                </div>
              )
            }

          </>
      }

    </Screen >
  );
}

export default Service